<template>
  <section v-if="context.post" class="c-section c-section--about">
    <div class="c-section-banner">
      <div class="container align-items-center justify-content-justify">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <h1 data-aos="fade-right" class="c-section-banner__title">
              {{ context.banner.title }}
            </h1>
          </div>
          <div class="col-12 col-md-6 col-lg-6">
            <figure class="c-section-banner__figure position-relative">
              <div class="c-section-banner__figure-shadow h-100">
                <img class="h-100" src="@/assets/images/banner-profile-shadow.png">
              </div>
                <img class="h-100 position-relative" src="@/assets/images/banner-profile.png">
            </figure>
          </div>
        </div>
      </div>
    </div>

    <div class="c-resume">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-12 col-lg-6">
            <div class="c-resume__content">
              <div id="centinel" class="c-title c-title--left">
                <span class="c-title__shadow">
                  {{ context.about.background_title }}
                </span>
                <span data-aos="fade-right" class="c-title__top secondary-color">
                  {{ context.about.subtitle }}
                </span>
                <h2 data-aos="fade-right" class="c-title__main pri-color">
                  {{ context.about.title }}
                </h2>
              </div>
              <div data-aos="fade-right" class="c-resume__info fs-16" v-html="context.post.content">
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-6">
            <figure data-aos="fade-left" class="c-resume__figure c-frame c-marco">
              <img class="w-100" :src="context.about.photo">
            </figure>
          </div>
        </div>
      </div>
    </div>

    <div class="c-clients">
      <div class="container">
        <div class="c-clients__title d-flex align-items-center">
          <div class="c-title c-title--left">
            <span class="c-title__shadow">
              {{ context.clients.background_title }}
            </span>
            <span data-aos="fade-right" class="c-title__top secondary-color">
              {{ context.clients.subtitle }}
            </span>
            <h2 data-aos="fade-right" class="c-title__main pri-color">
              {{ context.clients.title }}
            </h2>
          </div>
        </div>

        <div class="c-clients-list">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(client, iclient) of context.clients.gallery"
                :key="`client-${iclient}`"
                data-aos="fade-right"
                :data-aos-delay="100 * (iclient + 1)"
              >
                <div class="c-client position-relative">
                  <figure class="c-client__figure">
                    <img
                      class="w-100 h-100"
                      :src="client.photo ? client.photo : ''"
                    />
                  </figure>
                  <figcaption class="c-client__figcaption">
                    <h3 class="c-client__title">
                      {{ client.title }}
                    </h3>
                    <p class="c-client__client-name">
                      {{ client.subtitle }}
                    </p>
                  </figcaption>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper, { Pagination } from 'swiper';

Swiper.use([Pagination]);
export default {
  data() {
    return {
      context: {},
      contextLoading: true,
    };
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'about' });
  },
  watch: {
    contextLoading(state) {
      if (!state) {
        this.initClientsSlider();
      }
    },
  },
  mounted() {
    const headerEl = document.getElementsByClassName('c-header')[0];
    headerEl.classList.add('active');
  },
  methods: {
    initClientsSlider() {
      window.setTimeout(() => {
        this.clientsSlider = new Swiper('.c-clients .swiper-container', {
          slidesPerView: 1,
          spaceBetween: 30,
          autoHeight: true,
          pagination: {
            el: '.c-clients .swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    },
  },
};
</script>
